// ============================================================
// 🎨 THEME – MINI DESIGN SYSTEM
// Single source of truth for colors & UI tokens
// ============================================================

const THEME_KEY = 'appTheme';

// ── Theme definitions ────────────────────────────────────────
export const THEMES = {
  kuesto: {
    name: 'Kuesto',
    backgroundApp:      '#05006C',
    backgroundCard:     '#1A1A1A',
    backgroundToggle:   '#FFFFFF',
    backgroundPage:     '#05006C',
    backgroundDisabled: '#777777',
    textPrimary:        '#FFFFFF',
    textSecondary:      '#AAAAAA',
    textDisabled:       '#777777',
    actionBuy:          '#00FF88',
    actionSell:         '#FF4D4D',
    actionHold:         '#FFD166',
    toggleBuy:          '#4DFFB0',
    toggleSell:         '#FF7A7A',
    toggleHold:         '#FFE8A3',
    borderBuy:          '#00FF88',
    borderSell:         '#FF4D4D',
    borderHold:         '#FFD166',
    ctaPrimary:         '#00FF88',
    ctaPrimaryText:     '#05006C',
    previewDots:        ['#05006C', '#00FF88', '#FF4D4D'],
  },

  midnight: {
    name: 'Midnight',
    backgroundApp:      '#0A0A12',
    backgroundCard:     '#14141F',
    backgroundToggle:   '#FFFFFF',
    backgroundPage:     '#0A0A12',
    backgroundDisabled: '#555577',
    textPrimary:        '#E8E8FF',
    textSecondary:      '#8888AA',
    textDisabled:       '#555577',
    actionBuy:          '#00D4FF',
    actionSell:         '#FF4D6D',
    actionHold:         '#FFD166',
    toggleBuy:          '#66E8FF',
    toggleSell:         '#FF7A90',
    toggleHold:         '#FFE8A3',
    borderBuy:          '#00D4FF',
    borderSell:         '#FF4D6D',
    borderHold:         '#FFD166',
    ctaPrimary:         '#00D4FF',
    ctaPrimaryText:     '#0A0A12',
    previewDots:        ['#0A0A12', '#00D4FF', '#FF4D6D'],
  },

  jupiter: {
    name: 'Jupiter',
    backgroundApp:      '#1C0E05',
    backgroundCard:     '#2D1A0A',
    backgroundToggle:   '#D8D0C8',
    backgroundPage:     '#1C0E05',
    backgroundDisabled: '#4A3A30',
    textPrimary:        '#E0D8CC',
    textSecondary:      '#909080',
    textDisabled:       '#4A3A30',
    actionBuy:          '#C8C8C8',
    actionSell:         '#D94020',
    actionHold:         '#B0A898',
    toggleBuy:          '#E0E0E0',
    toggleSell:         '#F07050',
    toggleHold:         '#CCC0B0',
    borderBuy:          '#C8C8C8',
    borderSell:         '#D94020',
    borderHold:         '#B0A898',
    ctaPrimary:         '#C8C8C8',
    ctaPrimaryText:     '#1C0E05',
    previewDots:        ['#1C0E05', '#C8C8C8', '#D94020'],
  },

  saturn: {
    name: 'Saturn',
    backgroundApp:      '#0D0D1A',
    backgroundCard:     '#14142A',
    backgroundToggle:   '#F0E6C0',
    backgroundPage:     '#0D0D1A',
    backgroundDisabled: '#3A3A5A',
    textPrimary:        '#F0E6C0',
    textSecondary:      '#8A8060',
    textDisabled:       '#3A3A5A',
    actionBuy:          '#FFD700',
    actionSell:         '#FF6B9D',
    actionHold:         '#C8A8E8',
    toggleBuy:          '#FFE966',
    toggleSell:         '#FF9CBD',
    toggleHold:         '#DCC8F4',
    borderBuy:          '#FFD700',
    borderSell:         '#FF6B9D',
    borderHold:         '#C8A8E8',
    ctaPrimary:         '#FFD700',
    ctaPrimaryText:     '#0D0D1A',
    previewDots:        ['#0D0D1A', '#FFD700', '#FF6B9D'],
  },

  daylight: {
    name: 'Daylight',
    backgroundApp:      '#EEF2F8',
    backgroundCard:     '#FFFFFF',
    backgroundToggle:   '#1A1A2E',
    backgroundPage:     '#EEF2F8',
    backgroundDisabled: '#C8D0DC',
    textPrimary:        '#0F172A',
    textSecondary:      '#5A6A80',
    textDisabled:       '#C8D0DC',
    actionBuy:          '#0D7A50',
    actionSell:         '#C8251C',
    actionHold:         '#B86A00',
    toggleBuy:          '#1AA870',
    toggleSell:         '#E04040',
    toggleHold:         '#D48020',
    borderBuy:          '#0D7A50',
    borderSell:         '#C8251C',
    borderHold:         '#B86A00',
    ctaPrimary:         '#05006C',
    ctaPrimaryText:     '#FFFFFF',
    previewDots:        ['#EEF2F8', '#0D7A50', '#C8251C'],
  },

  forest: {
    name: 'Forest',
    backgroundApp:      '#0A1628',
    backgroundCard:     '#112240',
    backgroundToggle:   '#FFFFFF',
    backgroundPage:     '#0A1628',
    backgroundDisabled: '#445566',
    textPrimary:        '#CCD6F6',
    textSecondary:      '#8892B0',
    textDisabled:       '#445566',
    actionBuy:          '#64FFDA',
    actionSell:         '#FF6B6B',
    actionHold:         '#FFC107',
    toggleBuy:          '#A8FFE8',
    toggleSell:         '#FF9C9C',
    toggleHold:         '#FFD97D',
    borderBuy:          '#64FFDA',
    borderSell:         '#FF6B6B',
    borderHold:         '#FFC107',
    ctaPrimary:         '#64FFDA',
    ctaPrimaryText:     '#0A1628',
    previewDots:        ['#0A1628', '#64FFDA', '#FF6B6B'],
  },

  pastel: {
    name: 'Pastel',
    backgroundApp:      '#F5EFF8',
    backgroundCard:     '#FDFAFF',
    backgroundToggle:   '#3D2A6E',
    backgroundPage:     '#F5EFF8',
    backgroundDisabled: '#CBBFDC',
    textPrimary:        '#1E1040',
    textSecondary:      '#7868A8',
    textDisabled:       '#CBBFDC',
    actionBuy:          '#2E8B57',
    actionSell:         '#C04060',
    actionHold:         '#B07820',
    toggleBuy:          '#A8E6C8',
    toggleSell:         '#F0AAB8',
    toggleHold:         '#F0D88A',
    borderBuy:          '#2E8B57',
    borderSell:         '#C04060',
    borderHold:         '#B07820',
    ctaPrimary:         '#6040B0',
    ctaPrimaryText:     '#FFFFFF',
    previewDots:        ['#F5EFF8', '#A8E6C8', '#F0AAB8'],
  },

  highcontrast: {
    name: 'Alto Contrasto',
    backgroundApp:      '#000000',
    backgroundCard:     '#111111',
    backgroundToggle:   '#FFFFFF',
    backgroundPage:     '#000000',
    backgroundDisabled: '#555555',
    textPrimary:        '#FFFFFF',
    textSecondary:      '#DDDDDD',
    textDisabled:       '#555555',
    actionBuy:          '#00FF44',
    actionSell:         '#FF3300',
    actionHold:         '#FFDD00',
    toggleBuy:          '#66FF99',
    toggleSell:         '#FF7755',
    toggleHold:         '#FFEE66',
    borderBuy:          '#00FF44',
    borderSell:         '#FF3300',
    borderHold:         '#FFDD00',
    ctaPrimary:         '#FFDD00',
    ctaPrimaryText:     '#000000',
    previewDots:        ['#000000', '#00FF44', '#FF3300'],
  },
};

// ── Apply theme: scrive CSS custom properties sul root ───────
export const applyTheme = (key) => {
  const t = THEMES[key] || THEMES.kuesto;
  const root = document.documentElement.style;
  root.setProperty('--sem-bg-app',          t.backgroundApp);
  root.setProperty('--sem-bg-card',         t.backgroundCard);
  root.setProperty('--sem-bg-toggle',       t.backgroundToggle);
  root.setProperty('--sem-bg-page',         t.backgroundPage);
  root.setProperty('--sem-bg-disabled',     t.backgroundDisabled);
  root.setProperty('--sem-text-primary',    t.textPrimary);
  root.setProperty('--sem-text-secondary',  t.textSecondary);
  root.setProperty('--sem-text-disabled',   t.textDisabled);
  root.setProperty('--sem-action-buy',      t.actionBuy);
  root.setProperty('--sem-action-sell',     t.actionSell);
  root.setProperty('--sem-action-hold',     t.actionHold);
  root.setProperty('--sem-toggle-buy',      t.toggleBuy);
  root.setProperty('--sem-toggle-sell',     t.toggleSell);
  root.setProperty('--sem-toggle-hold',     t.toggleHold);
  root.setProperty('--sem-border-buy',      t.borderBuy);
  root.setProperty('--sem-border-sell',     t.borderSell);
  root.setProperty('--sem-border-hold',     t.borderHold);
  root.setProperty('--sem-cta-primary',     t.ctaPrimary);
  root.setProperty('--sem-cta-primary-text',t.ctaPrimaryText);
};

export const getThemeKey = () =>
  localStorage.getItem(THEME_KEY) || 'kuesto';

export const setTheme = (key) => {
  localStorage.setItem(THEME_KEY, key);
  applyTheme(key);
};

// ── SEMANTIC: riferimenti alle CSS custom properties ─────────
// Tutti i componenti usano questi alias. Il valore effettivo
// è risolto dalla variabile CSS, quindi cambia in tempo reale.
export const SEMANTIC = {
  backgroundApp:      'var(--sem-bg-app)',
  backgroundCard:     'var(--sem-bg-card)',
  backgroundToggle:   'var(--sem-bg-toggle)',
  backgroundPage:     'var(--sem-bg-page)',
  backgroundDisabled: 'var(--sem-bg-disabled)',
  textPrimary:        'var(--sem-text-primary)',
  textSecondary:      'var(--sem-text-secondary)',
  textDisabled:       'var(--sem-text-disabled)',
  actionBuy:          'var(--sem-action-buy)',
  actionSell:         'var(--sem-action-sell)',
  actionHold:         'var(--sem-action-hold)',
  toggleBuy:          'var(--sem-toggle-buy)',
  toggleSell:         'var(--sem-toggle-sell)',
  toggleHold:         'var(--sem-toggle-hold)',
  borderBuy:          'var(--sem-border-buy)',
  borderSell:         'var(--sem-border-sell)',
  borderHold:         'var(--sem-border-hold)',
  ctaPrimary:         'var(--sem-cta-primary)',
  ctaPrimaryText:     'var(--sem-cta-primary-text)',
};

// ── Legacy COLORS export (backward compatibility) ────────────
export const COLORS = {
  BRAND_BLUE:    { hex: '#05006C', rgb: '5, 0, 108' },
  BRAND_GREEN:   { hex: '#00FF88', rgb: '0, 255, 136' },
  BRAND_RED:     { hex: '#FF4D4D', rgb: '255, 77, 77' },
  BRAND_YELLOW:  { hex: '#FFD166', rgb: '255, 209, 102' },
  GREEN_SOFT:    { hex: '#4DFFB0', rgb: '77, 255, 176' },
  RED_SOFT:      { hex: '#FF7A7A', rgb: '255, 122, 122' },
  YELLOW_SOFT:   { hex: '#FFE8A3', rgb: '255, 232, 163' },
  WHITE:         { hex: '#FFFFFF', rgb: '255, 255, 255' },
  GRAY_TEXT:     { hex: '#AAAAAA', rgb: '170, 170, 170' },
  GRAY_DISABLED: { hex: '#777777', rgb: '119, 119, 119' },
  GRAY_DARK:     { hex: '#1A1A1A', rgb: '26, 26, 26' },
  GRAY_DARKER:   { hex: '#0F0F0F', rgb: '15, 15, 15' },
};

/* ============================================================
   🧩 COMMON UI TOKENS
   ============================================================ */
export const UI = {
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '20px',
    pill: '50px',
  },

  spacing: {
    sm: '6px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },

  fontWeight: {
    normal: 400,
    bold: 700,
  },

  shadow: {
    card: '0 4px 8px rgba(0, 0, 0, 0.7)',
    soft: '0 2px 4px rgba(0, 0, 0, 0.4)',
  },

  fontSize: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '20px',
    title: '24px',
  },

  transition: {
    fast: '0.2s ease',
    normal: '0.25s ease',
    slow: '0.35s ease',
  },
};

/* ============================================================
   🧭 NAV STYLE – stile barra navigazione inferiore
   ============================================================ */
const NAV_STYLE_KEY = 'appNavStyle';

export const NAV_STYLES = {
  text: {
    key: 'text',
    label: 'Testo',
    preview: ['Aa', 'Aa', 'Aa'],
  },
  icon: {
    key: 'icon',
    label: 'Icone',
    preview: ['📊', 'K', '⇄'],
  },
  'icon-text': {
    key: 'icon-text',
    label: 'Icone + Testo',
    preview: ['📊\nPerf', 'K\nPred', '⇄\nTrade'],
  },
};

export const getNavStyle = () =>
  localStorage.getItem(NAV_STYLE_KEY) || 'icon-text';

export const setNavStyle = (key) => {
  localStorage.setItem(NAV_STYLE_KEY, key);
};
